import { render } from "./MemberDetail.vue?vue&type=template&id=49632af8&scoped=true"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"

import "./MemberDetail.vue?vue&type=style&index=0&id=49632af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49632af8"]])

export default __exports__